export const image = [
  {
    "leetcodeLogo" :"https://raw.githubusercontent.com/mathcodes/contentfordevelopers/main/src/assets/Images/LeetCode_logo_black.png",
    "CforDLogo": "https://raw.githubusercontent.com/mathcodes/contentfordevelopers/main/src/assets/Images/CforD.png" 
  }
]